// hooks/useTableDensity.ts
import { useMemo } from 'react';
import { useSettings } from '../Settings/SettingsProvider';

export {
  TruncatedCell,
  DateTimeCell,
  NumericCell,
  ShortTextCell,
  ObjectArrayCell,
  RangeCell,
  isRangeObject,
  getRangeSortValue,
} from './tableCells';

export interface TableDensityClasses {
  tableCell: string;
  tableHeader: string;
  cellContent: string;
  button: string;
  text: string;
  cardHeader: string;
  icon: {
    small: string;
    medium: string;
    large: string;
  };
  truncation: {
    short: string;
    medium: string;
    long: string;
  };
}

export const useTableDensity = () => {
  const { settings } = useSettings();

  const tableDensity: 'normal' | 'compact' = useMemo(
    () => settings['ribbonPlugin.settings']?.table_density || 'normal',
    [settings],
  );

  const densityClasses: TableDensityClasses = useMemo(
    () => ({
      tableCell: tableDensity === 'compact' ? 'py-0 px-2' : 'py-1 px-4',
      tableHeader: tableDensity === 'compact' ? 'py-1 px-2' : 'py-2 px-4',
      cellContent: tableDensity === 'compact' ? 'py-0.5' : 'py-1',
      button: tableDensity === 'compact' ? 'size-6 p-0' : 'size-8 p-0',
      text: tableDensity === 'compact' ? 'text-xs' : 'text-sm',
      cardHeader:
        tableDensity === 'compact' ? 'px-4 py-2 pb-1' : 'px-7 py-4 pb-2',
      icon: {
        small: tableDensity === 'compact' ? 'size-3' : 'size-4',
        medium: tableDensity === 'compact' ? 'size-4' : 'size-5',
        large: tableDensity === 'compact' ? 'size-5' : 'size-6',
      },
      truncation: {
        short: tableDensity === 'compact' ? 'max-w-16' : 'max-w-24',
        medium: tableDensity === 'compact' ? 'max-w-20' : 'max-w-28',
        long: tableDensity === 'compact' ? 'max-w-24' : 'max-w-32',
      },
    }),
    [tableDensity],
  );

  return {
    tableDensity,
    densityClasses,
  };
};
